<template>
    <div class="my-tooltip">
        <span
            data-toggle="tooltip"
            @mouseenter="show = true"
            @mouseleave="show = false"
        >
            <slot></slot>
        </span>

        <div
            v-if="show"
            class="tooltip bs-tooltip-top show"
            role="tooltip"
        >
            <div class="arrow"></div>

            <div v-if="!slotTooltipInner" class="tooltip-inner" v-html="text" >
            </div>
            <div v-else class="tooltip-inner">
                <slot name="tooltip-inner">
                </slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
		props: {
			text: { required: true },
            slotTooltipInner: {
                type: Boolean,
                default: false
            }
        },
        
        data() {
            return {
                show: false,
            }
        },
    }
</script>
